var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeduimCompanies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.01 60.6162H6.75195V70.1215H21.01V60.6162Z",
    stroke: "#23262B",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.852 38.4371H21.0098V70.1216H36.852V38.4371Z",
    stroke: "#23262B",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6957 52.6952H36.8535V70.1216H52.6957V52.6952Z",
    stroke: "#23262B",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5375 30.516H52.6953V70.1216H68.5375V30.516Z",
    stroke: "#23262B",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0312 2H70.1208V13.0896",
    stroke: "#23262B",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.29 70.1216H2",
    stroke: "#23262B",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1216 2L40.0214 32.1002L24.1791 16.258L2 38.4371",
    stroke: "#23262B",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeduimCompanies);
export default __webpack_public_path__ + "static/media/meduimCompanies.cfe92ebe5bbdac581d6b1662b7bae4bb.svg";
export { ForwardRef as ReactComponent };